import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Urls } from '@core/config/urls';
import { Observable } from 'rxjs';
import { Registration } from '../models/registration';

@Injectable()
export class RegistrationService {
	constructor(private http: HttpClient) {}

	private get _url() {
		return Urls.BASE_URL.toString() + '/org-registration/initialize/registrations/users';
	}

	public createNewUser(registration: Registration): Observable<Registration> {
		return this.http.post<Registration>(this._url, registration);
	}
}
